import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { getColor } from 'ui/icons/utils';

export const EmptyStateJourneyGoals = ({
  height = 125,
  width = 125,
  color = colors.grey5,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 128 178" {...props}>
    <path
      d="M115.2 65.8137C115.201 58.1724 113.492 50.6276 110.197 43.7329C106.903 36.8382 102.107 30.7683 96.1608 25.9685C90.215 21.1686 83.2702 17.7605 75.8358 15.994C68.4014 14.2276 60.6659 14.1476 53.1965 15.76C45.7272 17.3724 38.7134 20.6362 32.6697 25.3122C26.626 29.9881 21.7055 35.9575 18.2692 42.7827C14.8329 49.6078 12.9678 57.1156 12.8109 64.7554C12.6539 72.3952 14.2089 79.9732 17.362 86.9338H110.638C113.65 80.3004 115.205 73.0988 115.2 65.8137Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M14.08 86.9338H113.92"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.31995 86.9338H11.5199"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M116.48 86.9338H119.68"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.9625 86.9402L72.5619 42.0915C72.7729 41.7485 73.0683 41.4652 73.4198 41.2686C73.7714 41.0721 74.1674 40.969 74.5702 40.969H76.6502C77.0528 40.9691 77.4486 41.0723 77.8 41.2688C78.1513 41.4653 78.4464 41.7486 78.6572 42.0915L106.258 86.9402H44.9625Z"
      fill={colors.purple20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.744 86.9402L35.6634 66.3104C35.7664 66.1298 35.9154 65.9796 36.0953 65.8751C36.2751 65.7707 36.4794 65.7156 36.6874 65.7156C36.8954 65.7156 37.0996 65.7707 37.2795 65.8751C37.4593 65.9796 37.6083 66.1298 37.7114 66.3104L49.6307 86.9402H23.744Z"
      fill={colors.purple20}
    />
    <path
      d="M44.9625 86.9402L72.5619 42.0915C72.7729 41.7485 73.0683 41.4652 73.4198 41.2686C73.7714 41.0721 74.1674 40.969 74.5702 40.969H76.6502C77.0528 40.9691 77.4486 41.0723 77.8 41.2688C78.1513 41.4653 78.4464 41.7486 78.6572 42.0915L106.258 86.9402H44.9625Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.744 86.9402L35.6634 66.3104C35.7664 66.1298 35.9154 65.9796 36.0953 65.8751C36.2751 65.7707 36.4794 65.7156 36.6874 65.7156C36.8954 65.7156 37.0996 65.7707 37.2795 65.8751C37.4593 65.9796 37.6083 66.1298 37.7114 66.3104L49.6307 86.9402H23.744Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.0253 86.9402L52.352 60.416C52.4552 60.2365 52.6039 60.0874 52.7831 59.9838C52.9624 59.8801 53.1657 59.8255 53.3728 59.8255C53.5798 59.8255 53.7832 59.8801 53.9624 59.9838C54.1416 60.0874 54.2904 60.2365 54.3936 60.416L69.7165 86.9402H37.0253Z"
      fill={colors.purple20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.9075 30.1427C40.2938 30.146 39.6861 30.2636 39.1155 30.4896C38.8102 28.543 37.8197 26.7696 36.3223 25.4888C34.825 24.208 32.9195 23.5042 30.9491 23.5042C28.9788 23.5042 27.0732 24.208 25.5759 25.4888C24.0786 26.7696 23.0881 28.543 22.7827 30.4896C22.1013 30.2258 21.3701 30.1154 20.6411 30.1663C19.9122 30.2171 19.2034 30.428 18.5651 30.7838C17.9269 31.1396 17.3749 31.6317 16.9484 32.225C16.5219 32.8184 16.2313 33.4984 16.0974 34.2168C15.9635 34.9351 15.9895 35.6741 16.1736 36.3813C16.3577 37.0885 16.6953 37.7464 17.1624 38.3083C17.6296 38.8702 18.2148 39.3222 18.8765 39.6323C19.5382 39.9424 20.26 40.1029 20.9907 40.1024H40.9075C42.2145 40.0814 43.4607 39.5476 44.3775 38.6159C45.2944 37.6843 45.8082 36.4296 45.8082 35.1226C45.8082 33.8155 45.2944 32.5608 44.3775 31.6292C43.4607 30.6975 42.2145 30.1637 40.9075 30.1427Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinejoin="round"
    />
    <path
      d="M40.9075 30.1427C40.2938 30.146 39.6861 30.2636 39.1155 30.4896C38.8102 28.543 37.8197 26.7696 36.3223 25.4888C34.825 24.208 32.9195 23.5042 30.9491 23.5042C28.9788 23.5042 27.0732 24.208 25.5759 25.4888C24.0786 26.7696 23.0881 28.543 22.7827 30.4896C22.1013 30.2258 21.3701 30.1154 20.6411 30.1663C19.9122 30.2171 19.2034 30.428 18.5651 30.7838C17.9269 31.1396 17.3749 31.6317 16.9484 32.225C16.5219 32.8184 16.2313 33.4984 16.0974 34.2168C15.9635 34.9351 15.9895 35.6741 16.1736 36.3813C16.3577 37.0885 16.6953 37.7464 17.1624 38.3083C17.6296 38.8702 18.2148 39.3222 18.8765 39.6323C19.5382 39.9424 20.26 40.1029 20.9907 40.1024H40.9075C42.2145 40.0814 43.4607 39.5476 44.3775 38.6159C45.2944 37.6843 45.8082 36.4296 45.8082 35.1226C45.8082 33.8155 45.2944 32.5608 44.3775 31.6292C43.4607 30.6975 42.2145 30.1637 40.9075 30.1427Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinejoin="round"
    />
    <path
      d="M75.6096 40.969V31.5392"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.6096 13.5846C75.6096 13.2458 75.6971 12.9128 75.8637 12.6178C76.0304 12.3229 76.2705 12.076 76.5607 11.9012C76.8509 11.7264 77.1814 11.6296 77.52 11.6202C77.8587 11.6109 78.194 11.6892 78.4935 11.8477L92.3687 19.2C92.6842 19.3671 92.9483 19.6171 93.1324 19.923C93.3166 20.2289 93.4139 20.5792 93.4139 20.9363C93.4139 21.2934 93.3166 21.6437 93.1324 21.9496C92.9483 22.2556 92.6842 22.5055 92.3687 22.6726L75.6096 31.5392V13.5846Z"
      fill={colors.purple20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M68.8218 62.1734C68.9286 62.3157 69.0661 62.432 69.2242 62.5135C69.3823 62.5951 69.5567 62.6398 69.7345 62.6443C69.9123 62.6489 70.0888 62.6132 70.2509 62.5398C70.4129 62.4665 70.5562 62.3574 70.6701 62.2208L74.7047 57.3798C74.8152 57.2469 74.9536 57.1399 75.1101 57.0665C75.2667 56.9931 75.4374 56.955 75.6103 56.955C75.7832 56.955 75.9539 56.9931 76.1105 57.0665C76.267 57.1399 76.4054 57.2469 76.5159 57.3798L80.5492 62.2208C80.6631 62.3574 80.8064 62.4665 80.9684 62.5398C81.1305 62.6132 81.307 62.6489 81.4848 62.6443C81.6626 62.6398 81.8371 62.5951 81.9951 62.5135C82.1532 62.432 82.2907 62.3157 82.3975 62.1734L87.1335 55.8618L78.6573 42.0915C78.4465 41.7486 78.1514 41.4653 77.8 41.2688C77.4487 41.0723 77.0529 40.9691 76.6503 40.969H74.5703C74.1675 40.969 73.7715 41.0721 73.4199 41.2686C73.0684 41.4652 72.773 41.7485 72.562 42.0915L64.0884 55.8618L68.8218 62.1734Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
